import React from 'react';
import {
  Box,
  Container,
  Typography,
  Grid,
  Card,
  CardContent,
  CardActions,
  Button,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Chip,
} from '@mui/material';
import CheckIcon from '@mui/icons-material/Check';
import { Link as RouterLink } from 'react-router-dom';
import { PRICING } from '../../config/site';

export default function PricingTable() {
  const handleGetStarted = (plan) => {
    if (window.gtag) {
      window.gtag('event', 'begin_checkout', { plan: plan || 'free' });
    }
  };

  const allPlans = [PRICING.free, ...PRICING.plans];

  return (
    <Box sx={{ py: 8 }}>
      <Container maxWidth="lg">
        <Typography
          variant="h3"
          component="h1"
          align="center"
          gutterBottom
          sx={{ mb: 2, fontWeight: 700 }}
        >
          Simple, Transparent Pricing
        </Typography>
        <Typography
          variant="h6"
          align="center"
          color="text.secondary"
          sx={{ mb: 6 }}
        >
          Start free. Upgrade when you're ready.
        </Typography>

        <Grid container spacing={4} justifyContent="center">
          {allPlans.map((plan) => {
            const isPopular = plan.key === 'starter';
            return (
              <Grid item xs={12} md={4} key={plan.name}>
                <Card
                  elevation={isPopular ? 8 : 2}
                  sx={{
                    height: '100%',
                    display: 'flex',
                    flexDirection: 'column',
                    position: 'relative',
                    border: isPopular ? 2 : 0,
                    borderColor: 'primary.main',
                    transform: isPopular ? 'scale(1.05)' : 'scale(1)',
                    transition: 'transform 0.2s',
                  }}
                >
                  {isPopular && (
                    <Chip
                      label="Most Popular"
                      color="primary"
                      sx={{
                        position: 'absolute',
                        top: -12,
                        left: '50%',
                        transform: 'translateX(-50%)',
                      }}
                    />
                  )}
                  <CardContent sx={{ flexGrow: 1, pt: isPopular ? 4 : 2 }}>
                    <Typography
                      variant="h5"
                      component="h2"
                      gutterBottom
                      sx={{ fontWeight: 700 }}
                    >
                      {plan.name}
                    </Typography>
                    <Box sx={{ mb: 3 }}>
                      <Typography
                        variant="h3"
                        component="span"
                        sx={{ fontWeight: 700 }}
                      >
                        ${plan.price}
                      </Typography>
                      {plan.price > 0 && (
                        <Typography
                          variant="h6"
                          component="span"
                          color="text.secondary"
                        >
                          /month
                        </Typography>
                      )}
                    </Box>

                    <List dense>
                      {plan.features.map((feature, idx) => (
                        <ListItem key={idx} disableGutters>
                          <ListItemIcon sx={{ minWidth: 36 }}>
                            <CheckIcon color="primary" />
                          </ListItemIcon>
                          <ListItemText
                            primary={feature}
                            primaryTypographyProps={{
                              variant: 'body2',
                            }}
                          />
                        </ListItem>
                      ))}
                    </List>

                    {plan.overage && (
                      <Typography
                        variant="caption"
                        color="text.secondary"
                        sx={{ display: 'block', mt: 2 }}
                      >
                        Overage: ${plan.overage}/min
                      </Typography>
                    )}
                  </CardContent>
                  <CardActions sx={{ p: 2, pt: 0 }}>
                    <Button
                      component={RouterLink}
                      to="/register"
                      variant={isPopular ? 'contained' : 'outlined'}
                      fullWidth
                      size="large"
                      onClick={() => handleGetStarted(plan.key)}
                    >
                      Get Started
                    </Button>
                  </CardActions>
                </Card>
              </Grid>
            );
          })}
        </Grid>

        <Typography
          variant="body2"
          align="center"
          color="text.secondary"
          sx={{ mt: 4 }}
        >
          All plans include organization isolation and secure JWT authentication.
          Minutes refer to audio duration processed, rounded up to nearest 15 seconds.
        </Typography>
      </Container>
    </Box>
  );
}
